(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qs-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header  = document.getElementById('qs-hdr');
  var openBtn = document.getElementById('qs-hdr-open');
  var closeBtn = document.getElementById('qs-hdr-close');
  var drawer  = document.getElementById('qs-drawer');
  var overlay = document.getElementById('qs-drawer-overlay');

  /* Scroll → swap background (skip when header is forced solid) */
  var forceSolid = header.getAttribute('data-force-solid') === 'true';
  function syncScroll() {
    if (forceSolid) return;
    if (window.scrollY > 0) {
      header.classList.add('qs-hdr--scrolled');
    } else {
      header.classList.remove('qs-hdr--scrolled');
    }
  }
  window.addEventListener('scroll', syncScroll, { passive: true });
  syncScroll();

  /* Mobile drawer */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  /* The cart drawer lives in the layout and listens on the document. When its
     trigger is the CART row inside THIS nav drawer, close the nav first — on the
     capture phase, so it happens before the cart drawer takes the body scroll
     lock and the two don't fight over restoring it. */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest('[data-qs-cart-open]');
      if (trigger && drawer.contains(trigger)) closeDrawer();
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();
})();
